module.exports = __webpack_public_path__ + "img/clean.d2469c89.png";